import { jsx as _jsx } from "react/jsx-runtime";
import { reportErrorToBugsnag } from "@air/utils-error";
import { createContext, memo, useContext, useMemo, useState } from "react";
import { isDevOrTestStage } from "~/swr-hooks/utils";
const defaultValue = {
    isExpanded: false,
    setIsExpanded: ()=>{}
};
const ImageSearchContext = /*#__PURE__*/ createContext(defaultValue);
export const ImageSearchContextProvider = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    const [isExpanded, setIsExpanded] = useState(false);
    const value = useMemo(()=>({
            isExpanded,
            setIsExpanded
        }), [
        isExpanded
    ]);
    return /*#__PURE__*/ _jsx(ImageSearchContext.Provider, {
        value: value,
        children: children
    });
});
ImageSearchContextProvider.displayName = "ImageSearchContextProvider";
export const useImageSearchContext = ()=>{
    const context = useContext(ImageSearchContext);
    if (context === defaultValue) {
        const error = new Error("useImageSearchContext must be used within a ImageSearchContextProvider");
        // Context not available, return default value instead of throwing
        if (isDevOrTestStage()) {
            throw error;
        } else {
            reportErrorToBugsnag({
                error,
                context: "ImageSearchContext not found"
            });
        }
    }
    return context;
};
